/**
 * jQuery plugin to lazy load images and iframes
 * depends on jquery.animateOnScroll.js, jquery.lazyIframe
 * created by bogdan.b@codingheads.com
 * requires IntersectionObserver, MutationObserver and jquery.animateOnScroll.js
 */

jQuery(function($) {
  // lazy-load iframes
  $.fn.chLazyLoad = function(useMutationObserver = true) {
    if (this.length) {
      // activate lazy interchange and lazy iframe
      const activate = $container => {
        // lazy images
        $container
          .find('[data-lazy-interchange], [data-lazy-bg], [data-lazy-img]')
          .not('[data-lazyimg-init]')
          .animateOnScroll({ initAttribute: 'lazyimgInit' });

        // lazy iframes
        if ('lazyIframe' in $.fn) {
          $container
            .find('[data-lazy-iframe]:not([data-lazyiframe-init])')
            .lazyIframe();
        }

        // lazy CSS
        $container
          .find('[data-lazy-css]:not([data-lazycss-init])')
          .animateOnScroll({
            initAttribute: 'lazycssInit',
            callback: target => {
              target.dataset.cssLoaded = true;
            },
          });
      };

      this.each(function() {
        const $this = $(this);

        // activate on page load
        activate($this);

        // observe if new elements are added - for example, by AJAX or infinite scroll
        if (useMutationObserver && 'MutationObserver' in window) {
          const observer = new MutationObserver(mutationList => {
            // check if new elements are added
            const addedNodes = mutationList.reduce(
              (added, mutation) => [
                ...added,
                ...[].filter.call(
                  mutation.addedNodes,
                  node => node.nodeType == Node.ELEMENT_NODE
                ),
              ],
              []
            );
            if (addedNodes.length) {
              // clear the initialization attributes on the new nodes, to allow lazy-load to work
              addedNodes.forEach(node => {
                node.removeAttribute('data-lazyimg-init');
                node.removeAttribute('data-lazyiframe-init');
                node.removeAttribute('data-lazycss-init');
                const toClear = node.querySelectorAll(
                  '[data-lazyimg-init], [data-lazyiframe-init], [data-lazycss-init]'
                );
                if (toClear.length)
                  toClear.forEach(item => {
                    item.removeAttribute('data-lazyimg-init');
                    item.removeAttribute('data-lazyiframe-init');
                    item.removeAttribute('data-lazycss-init');
                  });
              });
              activate($this);
            }
          });
          observer.observe(this, {
            attributes: false,
            childList: true,
            subtree: true,
          });
        }
      });
    }
    return this;
  };

  $(document).chLazyLoad();
});
